/** 白名单路径：不需要登录即可访问 */
export const publicPaths = [
  '/home',
  '/',
  '/user/login',
  '/user/register',
  '/user/register-result',
  '/editor',
];

/** 检查是否为公开路径 */
export const isPublicPath = (pathname: string) => publicPaths.includes(pathname);
